module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "id": "fotos",
      "name": "fotos"
    }
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('div', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_photos.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("ver fotos")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('fotos')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-center"
  }, [(_vm.window.width > 768) ? _c('carousel', {
    attrs: {
      "perPageCustom": [
        [768, 1],
        [1024, 1]
      ],
      "paginationSize": 12,
      "paginationActiveColor": '#D3D8DC'
    }
  }, _vm._l((_vm.fotos), function(foto, fotosIndex) {
    return _c('slide', {
      key: fotosIndex
    }, [_c('img', {
      staticClass: "textUbication foto-style",
      attrs: {
        "src": 'data:image/png;base64,' + foto
      }
    })])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.window.width < 768) ? _c('carousel', {
    attrs: {
      "perPageCustom": [
        [320, 1],
        [320 ]
      ],
      "paginationSize": 12,
      "paginationActiveColor": '#D3D8DC'
    }
  }, _vm._l((_vm.fotos), function(foto, fotosIndex) {
    return _c('slide', {
      key: fotosIndex
    }, [_c('img', {
      staticClass: "textUbication foto-style",
      attrs: {
        "src": 'data:image/png;base64,' + foto
      }
    })])
  }), 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.window.width > 510) ? _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "color": "#959FA9"
    }
  }, [_vm._v("Seguimiento de documento")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title title"
  }, [(_vm.window.width > 501) ? _c('span', {
    staticClass: "table-btn-icon"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.document.documentTypeName))])]) : _vm._e(), _vm._v(" "), (_vm.window.width < 510) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.document.documentTypeName))])])])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('router-link', {
    attrs: {
      "to": {
        name: 'DocumentSearch',
        params: {
          selectedAccount: this.selectedAccount,
          tracking: true,
          showAdvance: this.$route.params.showAdvanceMain
        }
      }
    }
  }, [_c('button', {
    class: 'btn btn-sm btn-success btnAction btn-search',
    staticStyle: {
      "margin-bottom": "30px",
      "width": "130px !important"
    }
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/ic_back.png"
    }
  }), _vm._v("Regresar")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder",
    staticStyle: {
      "padding-top": "12px !important",
      "height": "50px !important"
    }
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px"
    },
    attrs: {
      "src": "/static/img/icons/ic_doc2.png"
    }
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "text-tranform": "uppercase"
    }
  }, [_vm._v(_vm._s(_vm.document.documentTypeName + ' :'))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.document.documentNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "padding-top": "12px !important",
      "height": "70px !important"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('span', {
    staticClass: "client-box-title-side",
    staticStyle: {
      "color": "#009D00"
    }
  }, [_vm._v(_vm._s(_vm.document.supplierCustomerDescription))])])])]), _vm._v(" "), _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "padding-top": "12px",
      "padding-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.totalPackages)), _c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" " + _vm._s(_vm.minimumStockUnit))])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm._f("formatWeightKg")(_vm.totalWeight)))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm._f("formatVolM")(_vm.totalVolume)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Volumen ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D",
      "padding-top": "12px",
      "padding-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "5px"
    },
    attrs: {
      "src": "/static/img/icons/ic_calendar.png"
    }
  }), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.document.documentDate, 'DD/MM/YYYY')))]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.orderDeliveryDateConvert >= '2000') ? _c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "4px"
    },
    attrs: {
      "src": "/static/img/icons/ic_car.png"
    }
  }), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.document.orderDeliveryDate, 'DD/MM/YYYY')))]) : _c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "4px"
    },
    attrs: {
      "src": "/static/img/icons/ic_car.png"
    }
  }), _vm._v(" __/__/____")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.orderDeliveryDateConvert >= '2000') ? _c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/ic_time.png"
    }
  }), _vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.document.orderDeliveryDate, 'HH:mm')))]) : _c('span', [_c('img', {
    staticStyle: {
      "padding-bottom": "3px"
    },
    attrs: {
      "src": "/static/img/icons/ic_time.png"
    }
  }), _vm._v("__:__")]), _vm._v(" "), _vm._m(6)])])])])]), _vm._v(" "), ((this.indicatorViewOrder)) ? _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "padding-top": "12px",
      "padding-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.orderType))]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.trackingNumber))]), _vm._v(" "), _vm._m(8)])])]) : _vm._e(), _vm._v(" "), ((this.indicatorViewAddress)) ? _c('div', {
    staticClass: "title-boreder",
    staticStyle: {
      "padding-top": "12px",
      "padding-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.referenceDocumentNumber1))]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "font-size": "18px",
      "text-align": "center",
      "color": "#364A5D"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#364A5D"
    }
  }, [_vm._v(_vm._s(_vm.address1))]), _vm._v(" "), _vm._m(10)])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "box box-success",
    staticStyle: {
      "height": "385px !important"
    }
  }, [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "solid",
      "border-color": "#F6F6F6",
      "height": "100px !important"
    }
  }, [_c('div', {
    staticClass: "status-bar-"
  }, [_c('strong', {
    staticClass: "status-bar-title-percentage"
  }, [_vm._v(_vm._s(_vm.document.progress) + "%")]), _vm._v(" "), _c('strong', {
    staticClass: "status-bar-title"
  }, [_vm._v(_vm._s(_vm.document.status))])]), _vm._v(" "), (_vm.document.progress) ? _c('div', {
    staticClass: "progress status-bar"
  }, [_c('div', {
    class: 'progress-bar progress-bar-' + _vm.formatProgress(_vm.document.progress),
    style: ('width:' + _vm.document.progress + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.document.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "arkano-stepper",
    staticStyle: {
      "padding-top": "18px"
    }
  }, _vm._l((_vm.document.states), function(state, stateIndex) {
    return _c('div', {
      key: stateIndex,
      staticClass: "arkano-stepper-item"
    }, [_c('div', {
      staticClass: "arkano-stepper-label estateLine",
      staticStyle: {
        "color": "#364A5D"
      }
    }, [_c('strong', [_vm._v(_vm._s(state.name))])]), _vm._v(" "), _c('div', {
      class: _vm.stateCondition(state)
    }, [(state.done) ? _c('div', {
      staticClass: "arkano-stepper-check-border-true",
      staticStyle: {
        "background": "#364A5D"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/ic_check_blue.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.stateApply.name === state.name) ? _c('div', {
      staticClass: "arkano-stepper-check-border-next"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/oval_2x.png"
      }
    })]) : _vm._e(), _vm._v(" "), (!state.done && _vm.stateApply.name !== state.name) ? _c('div', {
      staticClass: "arkano-stepper-check-border-next"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/oval_2x.png"
      }
    })]) : _vm._e()]), _vm._v(" "), (state.done) ? _c('div', {
      staticClass: "arkano-stepper-label-bottom"
    }, [_c('strong', {
      staticStyle: {
        "color": "#364A5D"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(state.date, 'DD/MM/YYYY')))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#364A5D"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(state.date, 'HH:mm')))])]) : _vm._e(), _vm._v(" "), (!state.done) ? _c('div', {
      staticClass: "arkano-stepper-label-bottom"
    }, [_c('strong', {
      staticStyle: {
        "color": "#364A5D",
        "opacity": "0.3"
      }
    }, [_vm._v("__/__/____")]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#364A5D",
        "opacity": "0.3"
      }
    }, [_vm._v("__:__")])]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-success"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('carousel', {
    class: 'stepper-principal-box title-boreder',
    attrs: {
      "perPageCustom": [
        [768, 1],
        [1024, 6]
      ],
      "paginationSize": 12,
      "paginationActiveColor": '#D3D8DC'
    }
  }, _vm._l((_vm.document.events), function(event, eventIndex) {
    return _c('slide', {
      key: eventIndex,
      staticClass: "stepper-events-item"
    }, [_c('div', {
      staticClass: "stepper-check-events"
    }, [_c('div', {
      staticClass: "stepper-top-circle"
    }, [_c('div', {
      class: ((_vm.selectedEvent === eventIndex) ? 'stepper-item-circle-btn-select selected' : 'stepper-item-circle-btn-noselect'),
      on: {
        "click": function($event) {
          return _vm.showDetail(eventIndex, false)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "src": (_vm.selectedEvent === eventIndex) ? '/static/img/icons/ic_calendar_white.png' : '/static/img/icons/ic_calendar_black.png'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "vl"
    }), _vm._v(" "), _c('div', {
      class: 'stepper-item-box ' + ((_vm.selectedEvent === eventIndex) ? ' stepper-box-back-select' : ' stepper-box-back-noselect'),
      on: {
        "click": function($event) {
          return _vm.showDetail(eventIndex, false)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "padding-top": "8px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "24px"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(event.date, 'DD/MM/YYYY')))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(event.date, 'HH:mm')))]), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "900"
      }
    }, [_vm._v(_vm._s(event.name))]), _c('br')])]), _vm._v(" "), _c('div', {
      class: 'stepper-item-box-arrow ' + ((_vm.selectedEvent === eventIndex) ? 'stepper-item-box-arrow-bg' : '')
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h3', {
    staticClass: "box-title-sub",
    staticStyle: {
      "texrt-transform": "uppercase",
      "color": "#009D00",
      "font-weight": "bold",
      "font-family": "'Avenir', 'Arial'"
    }
  }, [_c('strong', [_vm._v("EVENTO: " + _vm._s(_vm.document.events[_vm.selectedEvent].name))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px !important"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_calendar.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.document.events[_vm.selectedEvent].date, 'DD/MM/YYYY')))]), _c('br'), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_time.png"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.document.events[_vm.selectedEvent].date, 'HH:mm')))]), _c('br'), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.ubicationState) ? _c('div', [_c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_location.png"
    }
  }), _c('a', {
    staticClass: "modal-fotos",
    staticStyle: {
      "font-size": "26px"
    },
    on: {
      "click": function($event) {
        return _vm.onUbicationModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.ubicacionStatus))])]) : _vm._e(), _vm._v(" "), (!_vm.ubicationState) ? _c('div', [_c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_location.png"
    }
  }), _c('a', {
    staticClass: "modal-fotos",
    staticStyle: {
      "font-size": "26px",
      "color": "black !important"
    }
  }, [_vm._v("Ubicación no disponible")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [(!_vm.fotoEnable) ? _c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_photos.png"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.fotoEnable) ? _c('span', {
    staticClass: "modal-fotos",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("Fotos no disponible")]) : _vm._e(), _vm._v(" "), (_vm.fotoEnable) ? _c('img', {
    staticStyle: {
      "padding-bottom": "10px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_photos.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fotoEnable) ? _c('a', {
    staticClass: "modal-fotos",
    staticStyle: {
      "font-size": "26px"
    },
    on: {
      "click": function($event) {
        return _vm.modalFotos()
      }
    }
  }, [_vm._v("ver fotos")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px !important"
    }
  }, [_c('h3', {
    staticClass: "box-title box-title-sub",
    staticStyle: {
      "text-transform": "uppercase",
      "color": "#4F6071",
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.document.events[0].name + ': PRODUCTOS'))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "detail"
    }
  }, [_c('vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "detail",
      "api-mode": false,
      "fields": _vm.tableFields,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.tableData,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "description",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Descripción"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.description))])])
      }
    }, {
      key: "provider",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Proveedor"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.provider))])])
      }
    }, {
      key: "totalPackages",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Cantidad"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.amount)), _c('span', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" " + _vm._s(_vm.minimumStockUnit))])])])
      }
    }, {
      key: "weight",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Peso"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.formatWeightKg(props.rowData.weight)))])])
      }
    }, {
      key: "volume",
      fn: function(props) {
        return _c('div', {
          attrs: {
            "id": "Volumen"
          }
        }, [_c('span', [_vm._v(_vm._s(_vm.formatVolM1(props.rowData.volume)))])])
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n             \n            "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n              Mostrando documento " + _vm._s(this.paginationData.from) + " a " + _vm._s(this.paginationData.to) + " de " + _vm._s(this.paginationData.total) + " en Total\n              ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "id": "ubication",
      "name": "ubication"
    }
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('div', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "6px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_location.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("ver ubicación")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ubication')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.ubicationState) ? _c('div', [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "475px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": this.center,
      "icon": "/static/img/icons/ic_truck_50.png"
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "color": "#959FA9",
      "margin-top": "0px"
    }
  }, [_vm._v("Seguimiento de documento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('span', {
    staticClass: "box-title box-title-sub client-pro-side cliente-prov-size-respo"
  }, [_vm._v("Cliente/Proveedor: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Total"), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Cantidad ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v(" Total "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Peso ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Fecha "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Emisión")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Fecha de "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Entrega")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Hora de "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("Entrega")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Tipo"), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v(" Número "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v("Número"), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Referencia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px"
    }
  }, [_vm._v(" Dirección "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v(" Despacho")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "5px",
      "padding-right": "8px"
    },
    attrs: {
      "src": "/static/img/icons/ic_estado.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("ESTADO")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "65px !important"
    }
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_vm._v("AVANCE ESTADO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-boreder"
  }, [_c('h3', {
    staticClass: "box-title-sub",
    staticStyle: {
      "padding-top": "0px !important"
    }
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "4px",
      "padding-right": "5px"
    },
    attrs: {
      "src": "/static/img/icons/ic_time.png"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("EVENTOS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eventBorder"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Fecha")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eventBorder"
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Hora")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21d32598!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitoring/DocumentMonitoring.vue
// module id = 507
// module chunks = 1